import { BusinessProcessType, WorkloadStandartType } from 'components/types/businessProcess';

export const mergeDetailProcess = (data: BusinessProcessType, standartActivity: WorkloadStandartType[], typeForm: number) => {
  const {
    behaviour_competencies, decision, financial, func_behaviour, func_competencies, last_update, non_financial, outcome,
    tech_behaviour, technical_competencies, order, order_number, child, parent_label, ...rest
  } = data;

  const categoryProcess = {
    1: 'Primary Process',
    2: 'Steering Governance',
    3: 'Support Process',
  };

  const mergeWorkload = standartActivity.map((val) => (
    {
      value: val.wla_template_id,
      activity_name: val.activity_name,
      standart_waktu: val.standart_waktu / 3600,
    }
  ));

  const dataMerged = {
    ...rest,
    category: categoryProcess[typeForm],
    dataWorkload: mergeWorkload,
    parent_id_label: data.parent_label,
  };

  return dataMerged;
};

export function mergeTreeProcess(datas:BusinessProcessType, typeForm: string) {
  const {
    behaviour_competencies, decision, financial, func_behaviour, func_competencies, last_update, non_financial,
    outcome, tech_behaviour, technical_competencies, order, order_number, child, main_indicator, name, objective, output, parent_label, ...rest
  } = datas;

  const parentLabel = typeForm === 'add_child'
    ? datas.name
    : datas.level === 1
      ? undefined
      : datas.parent_label;

  const dataMerged = {
    ...rest,
    category: datas.type,
    dataWorkload: [],
    name: '',
    parent_id: typeForm === 'add_child' ? datas.process_id : datas.parent_label,
    parent_id_label: parentLabel,
    objective: '',
    output: '',
    main_indicator: '',
    level: typeForm === 'add_child' ? datas.level + 1 : datas.level,
  };

  return dataMerged;
}
